import { useMutation } from '@tanstack/react-query';

import fetchPaymentReceipt from '../api/fetchPaymentReceipt';

const useFetchReceiptMutation = () => {
    const mutation = useMutation({
        mutationFn: fetchPaymentReceipt,
    });
    return mutation;
};

export default useFetchReceiptMutation;
